export default __webpack_public_path__ + "static/media/blue-bird.8cc172e8.png";